//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TABS = [
    '区域',
    '价格',
    '户型',
    '面积',
    '装修'
]
export default {
    data () {
        return {
            tabs: TABS
        }
    },
    methods: {
        onSelect (e) {
            const { tab } = e.currentTarget.dataset
            let selected = ''
            if (tab !== this.selected) {
                selected = tab
            }
            this.$emit('changeSelect', selected)
        },
        hideSelect () {
            this.$emit('changeSelect', '')
        }
    },
    props: {
        selected: {
            type: String
        },
        text: {
            type: Object
        }
    }
}
